import AppStoreService from "@/src/api/AppStoreService.js";

export function getAppStoreVersion(store) {
  try {
    const windowVersion = window.APP_STORE_CONFIG?.version;
    const storeVersion = store?.getters?.["appStore/appStoreVersion"];
    return (windowVersion || storeVersion || "v1").toString();
  } catch (error) {
    console.error('Error in getAppStoreVersion:', error);
    return "v1";
  }
}

export function isAppStoreV2(store) {
  return getAppStoreVersion(store).toLowerCase() === "v2";
}

export async function getInstalledAppCodes() {
  try {
    const response = await AppStoreService.getInstalledApps();
    if (response?.success && response?.installed_apps) {
      return response.installed_apps
        .map((item) => item?.app?.app_code)
        .filter(Boolean);
    }
    return [];
  } catch (error) {
    console.error("Error fetching installed app codes:", error);
    return [];
  }
}

export async function isAppInstalled(appCode) {
  try {
    const installedAppCodes = await getInstalledAppCodes();
    return installedAppCodes.includes(appCode);
  } catch (error) {
    console.error(`Error checking if app '${appCode}' is installed:`, error);
    return false;
  }
}

export async function checkNotetakerInstalled(store) {
  try {
    if (isAppStoreV2(store)) {
      return await isAppInstalled("ai_notetaker");
    }
    return true;
  } catch (error) {
    console.error("Error checking notetaker install status:", error);
    return false;
  }
}
